module.exports = __webpack_public_path__ + "img/cec.e4bad5d6.svg";